<template>
  <div
    class="wbs-content-top-bar d-flex flex-row shadow-sm flex-shrink-0"
    :class="classe"
  >
    <button
      type="button"
      class="btn btn-link wbs-side-menu-toggle"
      @click="toggleMenuLateral"
      title="Fechar/Abrir Menu Lateral"
      v-if="menuLateral"
    >
      <i
        class="mdi"
        :class="{ 'mdi-menu-left': toggle, 'mdi-menu-right': !toggle }"
      ></i>
    </button>
    <div class="d-flex flex-column wbs-content-top-bar__header mr-auto">
      <b-breadcrumb :items="items" />
    </div>
    <div class="wbs-content-top-bar__actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>
<script>
import eventHub from "../../utils/eventHub";

export default {
  name: "appPaginaBarraSuperior",
  props: {
    items: {
      type: Array,
      required: true
    },
    classe: {
      type: String
    },
    menuLateral: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      toggle: true
    };
  },
  methods: {
    toggleMenuLateral() {
      this.toggle = !this.toggle;
      eventHub.$emit("toggle-menu-lateral", this.toggle);
    },
    menuResponsivo(val) {
      this.toggle = !val;
    }
  },
  created() {
    eventHub.$on("toggle-menu-lateral-responsivo", this.menuResponsivo);
  }
};
</script>
<style lang="scss">
.wbs-content-top-bar {
  margin-bottom: 0.5rem;
  background-color: #fff;

  @include element("header") {
    padding-top: 0.5rem;

    & h4 {
      font-size: 1.3rem;
      margin-bottom: 0;
    }

    & p {
      font-size: 0.8rem;
    }
  }

  @include element("actions") {
    margin: auto 0;
    margin-right: 16px;
  }

  @include modifier("ml-3") {
    .wbs-content-top-bar__header {
      margin-left: 3rem !important;
    }
  }

  .breadcrumb {
    padding: 10px 0;
    background-color: transparent;
    margin-bottom: 0.5rem;

    & .breadcrumb-item {
      font-weight: 500;
      a {
        color: #2d6f51;
      }

      &.active {
        font-weight: 600;
        color: #2e2e2e;
      }
    }
  }
}
.wbs-close-side-menu {
  color: #b8b5c0;
  &:hover,
  &:focus {
    opacity: 0.5;
    color: #b8b5c0;
  }
}
</style>
